import styled from 'styled-components';

const StyledAppSidebar = styled.div`
    aside.app-sidebar {
        min-height: 100vh;
        height: 100%;
        border-right: 1px solid rgb(240, 240, 240);
        background: #ffffff;
        .app-sidebar__menu {
            background: inherit;
        }
        .ant-layout-sider-trigger {
            border-right: inherit;
            background: inherit;
        }
    }
`;

export default StyledAppSidebar;
